const en = {
	nameSurname: 'Name Surname',
	start: 'Start',
	end: 'End',
	search: 'Search',
	logOut: 'Log Out',
	signIn: 'Sign in',
	rememberMe: 'Remember Me',
	emptyData: 'No data available at the specified time',
	wrong: 'Wrong',
	usernameOrPassword: 'username or password',
	daterange: {
		this_day: 'This day',
		this_week: 'This week',
		last_week: 'Last week',
		last_7_days: 'Last 7 days',
		this_month: 'This month',
		next_month: 'Next month',
		reset: 'Reset',
	},
	langSelect: 'Language',
}

export default en
